(function () {
  'use strict';

  /* Add lp-js class immediately to enable CSS animations */
  document.body.classList.add('hs-lp-js');

  /* ── Scroll reveal ────────────────────────────────────── */
  function initReveal() {
    var els = document.querySelectorAll('.hs-lp-reveal');
    if (!els.length) return;
    var timer = setTimeout(function () {
      els.forEach(function (el) { el.classList.add('hs-lp-revealed'); });
    }, 2000);
    if (!window.IntersectionObserver) {
      clearTimeout(timer);
      els.forEach(function (el) { el.classList.add('hs-lp-revealed'); });
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('hs-lp-revealed');
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -20px 0px' });
    els.forEach(function (el) { obs.observe(el); });
  }

  /* ── Counter animation ────────────────────────────────── */
  function animateCounter(el) {
    var target = parseFloat(el.dataset.count || 0);
    var suffix = el.dataset.suffix || '';
    var prefix = el.dataset.prefix || '';
    var dur    = 1600;
    var start  = null;
    (function tick(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var e = 1 - Math.pow(1 - p, 3);
      var v = target * e;
      el.textContent = prefix + (target % 1 !== 0 ? v.toFixed(1) : Math.round(v)) + suffix;
      if (p < 1) requestAnimationFrame(tick);
    })(performance.now());
  }

  function initCounters() {
    if (!window.IntersectionObserver) return;
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { animateCounter(e.target); obs.unobserve(e.target); }
      });
    }, { threshold: 0.5 });
    document.querySelectorAll('[data-count]').forEach(function (el) { obs.observe(el); });
  }

  /* ── Bar chart ────────────────────────────────────────── */
  function initChart() {
    var fills = document.querySelectorAll('.hs-lp-bar__fill');
    if (!fills.length) return;
    if (!window.IntersectionObserver) {
      fills.forEach(function (b) { b.style.width = b.dataset.width; });
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.querySelectorAll('.lp-bar__fill').forEach(function (b) {
            setTimeout(function () { b.style.width = b.dataset.width; }, 80);
          });
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.3 });
    document.querySelectorAll('.hs-lp-chart').forEach(function (el) { obs.observe(el); });
  }

  /* ── Before/After slider ──────────────────────────────── */
  function initBeforeAfter() {
    var slider = document.querySelector('.hs-lp-ba');
    if (!slider) return;
    var handle = slider.querySelector('.lp-ba__handle');
    var after  = slider.querySelector('.lp-ba__after');
    var drag   = false;
    function setPos(x) {
      var r   = slider.getBoundingClientRect();
      var pct = Math.max(5, Math.min(95, ((x - r.left) / r.width) * 100));
      after.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0)';
      handle.style.left    = pct + '%';
    }
    handle.addEventListener('mousedown',  function (e) { drag = true; e.preventDefault(); });
    handle.addEventListener('touchstart', function ()  { drag = true; }, { passive: true });
    document.addEventListener('mousemove',  function (e) { if (drag) setPos(e.clientX); });
    document.addEventListener('touchmove',  function (e) { if (drag) setPos(e.touches[0].clientX); }, { passive: true });
    document.addEventListener('mouseup',  function () { drag = false; });
    document.addEventListener('touchend', function () { drag = false; });
    slider.addEventListener('click', function (e) { setPos(e.clientX); });
    setPos(slider.getBoundingClientRect().left + slider.getBoundingClientRect().width / 2);
  }

  /* ── FAQ accordion ────────────────────────────────────── */
  function initFaq() {
    document.querySelectorAll('.hs-lp-faq__q').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item   = btn.closest('.lp-faq__item');
        var isOpen = item.classList.contains('hs-lp-open');
        document.querySelectorAll('.hs-lp-faq__item').forEach(function (i) { i.classList.remove('hs-lp-open'); });
        if (!isOpen) item.classList.add('hs-lp-open');
      });
    });
  }

  /* ── Sticky bar ───────────────────────────────────────── */
  function initStickyBar() {
    var hero = document.querySelector('.hs-lp-hero');
    var bar  = document.querySelector('.hs-lp-sticky-bar');
    if (!hero || !bar || !window.IntersectionObserver) return;
    new IntersectionObserver(function (entries) {
      bar.classList.toggle('hs-lp-visible', !entries[0].isIntersecting);
    }, { threshold: 0 }).observe(hero);
  }

  /* ── Countdown timer ──────────────────────────────────── */
  function initCountdown() {
    var elH = document.getElementById('hs-lp-cd-h');
    var elM = document.getElementById('hs-lp-cd-m');
    var elS = document.getElementById('hs-lp-cd-s');
    var elH2 = document.getElementById('hs-lp-cd-h2');
    var elM2 = document.getElementById('hs-lp-cd-m2');
    var elS2 = document.getElementById('hs-lp-cd-s2');
    if ((!elH || !elM || !elS) && (!elH2 || !elM2 || !elS2)) return;
    var cdEl     = document.getElementById('hs-lp-countdown');
    var deadline = cdEl && cdEl.getAttribute('data-deadline');
    var endTime;
    {
      var key    = 'skcd_deadline';
      var stored = parseInt(sessionStorage.getItem(key) || '0', 10);
      var ONE_HOUR = 3600000;
      /* Reset if missing, expired, or was set to more than 1h from now (stale 23h value) */
      if (!stored || stored <= Date.now() || stored > Date.now() + ONE_HOUR + 5000) {
        stored = Date.now() + ONE_HOUR;
        sessionStorage.setItem(key, stored);
      }
      endTime = stored;
    }
    function tick() {
      var remaining = Math.max(0, endTime - Date.now());
      var h = Math.floor(remaining / 3600000);
      var m = Math.floor((remaining % 3600000) / 60000);
      var s = Math.floor((remaining % 60000) / 1000);
      var hh = String(h).padStart(2, '0'), mm = String(m).padStart(2, '0'), ss = String(s).padStart(2, '0');
      if (elH) { elH.textContent = hh; elM.textContent = mm; elS.textContent = ss; }
      if (elH2) { elH2.textContent = hh; elM2.textContent = mm; elS2.textContent = ss; }
      if (remaining > 0) setTimeout(tick, 1000);
    }
    tick();
  }

  /* ── Tablet Upsell Modal (LP version) ─────────────────── */
  var lpTuModal    = null;
  var lpTuVariant  = null;
  var lpTuPlan     = null;
  var lpTuQty      = 1;

  /* Pending bundle (device) state — set on ATC click, refined in the model popup,
     consumed by the tablet popup on confirm/skip. */
  var lpBundleReg   = null;      /* Regular variant id to add */
  var lpBundleDeuce = '';        /* Deuce (Kohler) variant id, '' if none */
  var lpPackSize    = 1;         /* number of devices in the pack */
  var lpMix         = false;     /* true → buyer chooses how many of each model */
  var lpDeviceModel = 'regular'; /* 'regular' | 'deuce' — used when NOT mixing */
  var lpMixReg      = 0;         /* mix: how many Regular */
  var lpMixDeuce    = 0;         /* mix: how many Deuce */

  /* Auto-subscription state (subscription pages): when set, the tablet popup is
     skipped and a tablet subscription line is auto-added alongside the devices. */
  var lpAutoSub    = false;      /* true → auto-include the tablet subscription, no tablet popup */
  var lpSubVariant = '';         /* tablet variant id to auto-subscribe (e.g. 12-pack) */
  var lpSubPlan    = '';         /* selling plan id (e.g. Every 3 Months) */
  var lpSubQty     = 1;          /* how many of the subscription variant to add */

  function parsePlanPrices(str) {
    var r = {};
    if (!str) return r;
    str.split('|').forEach(function (e) {
      var parts = e.split(':');
      if (parts[0] && parts[1]) r[parts[0]] = parseInt(parts[1], 10);
    });
    return r;
  }
  function fmt(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  /* Build the /cart/add.js line items for the chosen device model(s). */
  function deviceItems() {
    if (lpMix) {
      var arr = [];
      if (lpMixReg   > 0 && lpBundleReg)   arr.push({ id: parseInt(lpBundleReg, 10),   quantity: lpMixReg });
      if (lpMixDeuce > 0 && lpBundleDeuce) arr.push({ id: parseInt(lpBundleDeuce, 10), quantity: lpMixDeuce });
      return arr;
    }
    var vid = (lpDeviceModel === 'deuce' && lpBundleDeuce) ? parseInt(lpBundleDeuce, 10) : parseInt(lpBundleReg, 10);
    return vid ? [{ id: vid, quantity: 1 }] : [];
  }

  function initTabletModal() {
    lpTuModal = document.getElementById('lp-tu-modal');
    if (!lpTuModal) return;

    var sizeBtns   = lpTuModal.querySelectorAll('[data-upsell-size-btn]');
    var planRadios = lpTuModal.querySelectorAll('[data-upsell-plan-radio]');
    var planOpts   = lpTuModal.querySelectorAll('[data-upsell-plan-option]');
    var confirmBtn = document.getElementById('lp-tu-confirm');
    var skipBtn    = document.getElementById('lp-tu-skip');
    var closeBtn   = document.getElementById('lp-tu-close');
    var backdrop   = document.getElementById('lp-tu-backdrop');
    var qtyVal     = document.getElementById('lp-tu-qty-val');
    var qtyDec     = document.getElementById('lp-tu-qty-dec');
    var qtyInc     = document.getElementById('lp-tu-qty-inc');

    var confirmDefaultText = confirmBtn ? confirmBtn.textContent.trim() : 'Yes! Add Tablets to My Order';
    var skipDefaultText    = skipBtn ? skipBtn.textContent.trim() : "No thanks, I'll skip the tablets";
    var lpTuAdding = false; /* shared lock: only one add request in flight at a time */

    var curSizeBtn = sizeBtns.length ? sizeBtns[0] : null;
    lpTuVariant = curSizeBtn ? curSizeBtn.dataset.upsellSizeBtn : null;
    lpTuPlan    = null;
    lpTuQty     = 1;

    function updatePrices() {
      if (!curSizeBtn) return;
      var onePrice   = parseInt(curSizeBtn.dataset.oneTimePrice, 10);
      var planPrices = parsePlanPrices(curSizeBtn.dataset.planPrices);
      var onePriceEl = lpTuModal.querySelector('[data-upsell-plan-price="one_time"]');
      if (onePriceEl) onePriceEl.textContent = fmt(onePrice);
      Object.keys(planPrices).forEach(function (pid) {
        var pEl = lpTuModal.querySelector('[data-upsell-plan-price="' + pid + '"]');
        if (pEl) pEl.textContent = fmt(planPrices[pid]);
      });
    }
    function updateQty() {
      if (qtyVal) qtyVal.textContent = lpTuQty;
      if (qtyDec) qtyDec.disabled = lpTuQty <= 1;
    }

    sizeBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        curSizeBtn  = btn;
        lpTuVariant = btn.dataset.upsellSizeBtn;
        sizeBtns.forEach(function (b) { b.classList.toggle('is-selected', b === btn); });
        updatePrices();
      });
    });

    planRadios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        lpTuPlan = radio.dataset.upsellSellingPlanId || null;
        planOpts.forEach(function (opt) { opt.classList.toggle('is-selected', opt.contains(radio)); });
      });
    });

    if (qtyDec) qtyDec.addEventListener('click', function () { if (lpTuQty > 1) { lpTuQty--; updateQty(); } });
    if (qtyInc) qtyInc.addEventListener('click', function () { lpTuQty++; updateQty(); });

    if (confirmBtn) {
      confirmBtn.addEventListener('click', async function () {
        if (lpTuAdding) return;
        var items = deviceItems();
        if (!items.length) { closeModal(); openSideCart(); return; }
        lpTuAdding = true;
        confirmBtn.disabled = true;
        if (skipBtn) skipBtn.disabled = true;
        confirmBtn.textContent = 'Adding…';
        try {
          var tabletVid = parseInt(lpTuVariant, 10);
          if (tabletVid) {
            var t = { id: tabletVid, quantity: lpTuQty };
            if (lpTuPlan) t.selling_plan = parseInt(lpTuPlan, 10);
            items.push(t);
          }
          var r = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: items })
          });
          var d = await r.json();
          if (d.status && d.status !== 200) throw new Error(d.description);
          confirmBtn.textContent = '✓ Added!';
          setTimeout(function () { closeModal(); openSideCart(); }, 700);
        } catch (e) {
          lpTuAdding = false;
          confirmBtn.disabled = false;
          if (skipBtn) skipBtn.disabled = false;
          confirmBtn.textContent = confirmDefaultText;
        }
      });
    }

    function closeModal() {
      lpTuModal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    if (skipBtn) {
      skipBtn.addEventListener('click', async function () {
        if (lpTuAdding) return;
        var items = deviceItems();
        if (!items.length) { closeModal(); openSideCart(); return; }
        lpTuAdding = true;
        skipBtn.disabled = true;
        if (confirmBtn) confirmBtn.disabled = true;
        skipBtn.textContent = 'Adding…';
        try {
          var r = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: items })
          });
          var d = await r.json();
          if (d.status && d.status !== 200) throw new Error(d.description);
          closeModal(); openSideCart();
        } catch (e) {
          lpTuAdding = false;
          skipBtn.disabled = false;
          if (confirmBtn) confirmBtn.disabled = false;
          skipBtn.textContent = skipDefaultText;
        }
      });
    }
    if (closeBtn)  closeBtn.addEventListener('click',  closeModal);
    if (backdrop)  backdrop.addEventListener('click',  closeModal);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModal(); });

    /* Store reset for re-opening */
    lpTuModal._reset = function () {
      lpTuQty     = 1;
      curSizeBtn  = sizeBtns[0] || null;
      lpTuVariant = curSizeBtn ? curSizeBtn.dataset.upsellSizeBtn : null;
      lpTuAdding = false;
      updateQty();
      sizeBtns.forEach(function (b, i) { b.classList.toggle('is-selected', i === 0); });
      // Default to the first Subscribe & Save plan if one exists, else one-time
      var defIdx = 0;
      for (var i = 0; i < planRadios.length; i++) {
        if (planRadios[i].dataset.upsellSellingPlanId) { defIdx = i; break; }
      }
      lpTuPlan = planRadios[defIdx] ? (planRadios[defIdx].dataset.upsellSellingPlanId || null) : null;
      planRadios.forEach(function (r, i) { r.checked = i === defIdx; });
      planOpts.forEach(function (opt, i) { opt.classList.toggle('is-selected', i === defIdx); });
      if (confirmBtn) { confirmBtn.disabled = false; confirmBtn.textContent = confirmDefaultText; }
      if (skipBtn) { skipBtn.disabled = false; skipBtn.textContent = skipDefaultText; }
      updatePrices();
    };
  }

  function openTabletModal() {
    if (!lpTuModal) return false;
    if (lpTuModal._reset) lpTuModal._reset();
    lpTuModal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    return true;
  }

  /* ── Step 1: model-selection popup ─────────────────────── */
  var lpMmModal = null;
  function initModelModal() {
    lpMmModal = document.getElementById('lp-model-modal');
    if (!lpMmModal) return;

    var toggleWrap  = document.getElementById('lp-mm-toggle');
    var mixWrap     = document.getElementById('lp-mm-mix');
    var rowDeuce    = document.getElementById('lp-mm-row-deuce');
    var regVal      = document.getElementById('lp-mm-reg-val');
    var deuceVal    = document.getElementById('lp-mm-deuce-val');
    var countEl     = document.getElementById('lp-mm-count');
    var continueBtn = document.getElementById('lp-mm-continue');
    var closeBtn    = document.getElementById('lp-mm-close');
    var backdrop    = document.getElementById('lp-mm-backdrop');
    var modelBtns   = lpMmModal.querySelectorAll('[data-mm-model]');
    var stepBtns    = lpMmModal.querySelectorAll('[data-mm-step]');

    function renderMix() {
      if (regVal)   regVal.textContent   = lpMixReg;
      if (deuceVal) deuceVal.textContent = lpMixDeuce;
      if (countEl)  countEl.textContent  = '(' + lpMixReg + ' Regular + ' + lpMixDeuce + ' Canister Edition = ' + lpPackSize + ')';
    }

    modelBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        lpDeviceModel = btn.dataset.mmModel === 'deuce' ? 'deuce' : 'regular';
        modelBtns.forEach(function (b) { b.classList.toggle('is-selected', b === btn); });
      });
    });

    /* Complementary steppers: the two counts always sum to lpPackSize. */
    stepBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        /* No Deuce variant → the whole pack stays Regular; steppers are inert. */
        if (!lpBundleDeuce) { lpMixReg = lpPackSize; lpMixDeuce = 0; renderMix(); return; }
        var which = btn.dataset.mmStep;             /* 'reg' | 'deuce' */
        var dir   = parseInt(btn.dataset.mmDir, 10);/* +1 | -1 */
        if (which === 'reg') {
          if (dir > 0 && lpMixReg   < lpPackSize) { lpMixReg++; lpMixDeuce--; }
          else if (dir < 0 && lpMixReg   > 0)     { lpMixReg--; lpMixDeuce++; }
        } else {
          if (dir > 0 && lpMixDeuce < lpPackSize) { lpMixDeuce++; lpMixReg--; }
          else if (dir < 0 && lpMixDeuce > 0)     { lpMixDeuce--; lpMixReg++; }
        }
        renderMix();
      });
    });

    function closeMm() {
      lpMmModal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
    if (continueBtn) {
      continueBtn.addEventListener('click', function () {
        closeMm();
        /* Auto-subscription page: skip the tablet popup, add devices + the tablet subscription. */
        if (lpAutoSub) { addDevicesWithSub(); return; }
        /* Step 2: hand off to the tablet popup; add devices directly if it's absent. */
        if (!openTabletModal()) addDevicesDirect();
      });
    }
    if (closeBtn) closeBtn.addEventListener('click', closeMm);
    if (backdrop) backdrop.addEventListener('click', closeMm);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && lpMmModal.getAttribute('aria-hidden') === 'false') closeMm();
    });

    /* Configure the popup for the pending pack each time it opens. */
    lpMmModal._open = function () {
      if (lpMix) {
        /* Multi-pack mix: default the whole pack to Regular. */
        lpMixReg = lpPackSize; lpMixDeuce = 0;
        if (toggleWrap) toggleWrap.hidden = true;
        if (mixWrap)    mixWrap.hidden = false;
        if (rowDeuce)   rowDeuce.hidden = !lpBundleDeuce;
        renderMix();
      } else {
        /* Single-model toggle. */
        lpDeviceModel = 'regular';
        if (mixWrap)    mixWrap.hidden = true;
        if (toggleWrap) toggleWrap.hidden = false;
        modelBtns.forEach(function (b) {
          b.classList.toggle('is-selected', b.dataset.mmModel !== 'deuce');
          if (b.dataset.mmModel === 'deuce') b.style.display = lpBundleDeuce ? '' : 'none';
        });
      }
    };
  }

  function openModelModal() {
    if (!lpMmModal) return false;
    if (lpMmModal._open) lpMmModal._open();
    lpMmModal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    return true;
  }

  /* Fallback add path when no tablet popup is present. */
  async function addDevicesDirect() {
    var items = deviceItems();
    if (!items.length) { openSideCart(); return; }
    try {
      var r = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      });
      var d = await r.json();
      if (d.status && d.status !== 200) throw new Error(d.description);
      openSideCart();
    } catch (e) {}
  }

  /* Auto-subscription add path: devices + an auto-included tablet subscription, no tablet popup. */
  async function addDevicesWithSub() {
    var items = deviceItems();
    if (lpSubVariant) {
      var sub = { id: parseInt(lpSubVariant, 10), quantity: lpSubQty > 0 ? lpSubQty : 1 };
      if (lpSubPlan) sub.selling_plan = parseInt(lpSubPlan, 10);
      items.push(sub);
    }
    if (!items.length) { openSideCart(); return; }
    try {
      var r = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      });
      var d = await r.json();
      if (d.status && d.status !== 200) throw new Error(d.description);
      openSideCart();
    } catch (e) {}
  }

  /* ── Open side cart (falls back to /cart page) ─────────── */
  function openSideCart() {
    if (window.CartDrawer && typeof window.CartDrawer.refresh === 'function') {
      window.CartDrawer.refresh().then(function () {
        window.CartDrawer.open();
        syncTopbarCartCount();
      }).catch(function () {
        if (typeof window.CartDrawer.open === 'function') window.CartDrawer.open();
        syncTopbarCartCount();
      });
    } else {
      window.location.href = '/cart';
    }
  }

  function syncTopbarCartCount() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var el = document.getElementById('hs-lp-topbar-cart-count');
        if (!el) return;
        var count = cart.item_count || 0;
        el.textContent = count;
        el.style.display = count > 0 ? 'flex' : 'none';
      }).catch(function(){});
  }

  /* ── Add to cart: step 1 (model) → step 2 (tablets) → add ──── */
  async function addBundleToCart(btn) {
    var reg   = btn.dataset.deviceRegular || btn.dataset.deviceVariant;
    var deuce = btn.dataset.deviceDeuce || '';
    if (!reg) return;

    lpBundleReg   = reg;
    lpBundleDeuce = deuce;
    lpPackSize    = +(btn.dataset.packSize || 1);
    lpMix         = btn.dataset.mix === 'true';
    lpDeviceModel = 'regular';
    lpMixReg      = lpPackSize;
    lpMixDeuce    = 0;

    lpAutoSub    = btn.dataset.autoSub === 'true';
    lpSubVariant = btn.dataset.subVariant || '';
    lpSubPlan    = btn.dataset.subPlan || '';
    lpSubQty     = +(btn.dataset.subQty || 1);

    /* Step 1: model popup. Devices are added later (on tablet confirm/skip, or auto-sub add). */
    if (openModelModal()) return;
    /* No model popup but auto-sub → add devices + subscription directly. */
    if (lpAutoSub) { addDevicesWithSub(); return; }
    /* No model popup → go straight to the tablet popup. */
    if (openTabletModal()) return;

    /* Neither popup present → add the Regular device(s) immediately. */
    var origText = btn.textContent.trim();
    btn.disabled    = true;
    btn.textContent = 'Adding…';
    try {
      var r = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: deviceItems() })
      });
      var d = await r.json();
      if (d.status && d.status !== 200) throw new Error(d.description);
      btn.disabled    = false;
      btn.textContent = origText;
      openSideCart();
    } catch (e) {
      btn.disabled    = false;
      btn.textContent = origText;
    }
  }

  /* ── Init ─────────────────────────────────────────────── */
  function initOfferCards() {
    var cards = document.querySelectorAll('.lp-ofb-card');
    var priceOrig = document.querySelector('.lp-ofb-panel__price-orig');
    var priceSale = document.querySelector('.lp-ofb-panel__price-sale');
    var priceSavings = document.querySelector('.lp-ofb-panel__price-savings');
    var atcBtn = document.querySelector('.lp-ofb-atc');

    function selectCard(card) {
      cards.forEach(function (c) { c.classList.remove('lp-ofb-card--selected'); });
      card.classList.add('lp-ofb-card--selected');

      var sale = card.dataset.priceLabel;
      var orig = card.dataset.priceOrig;
      var savings = card.dataset.priceSavings;

      if (priceSale && sale) priceSale.textContent = sale;
      if (priceOrig) {
        priceOrig.textContent = orig || '';
        priceOrig.style.display = orig ? '' : 'none';
      }
      if (priceSavings) {
        priceSavings.textContent = savings || '';
        priceSavings.style.display = savings ? '' : 'none';
      }

      if (atcBtn) {
        ['packSize','mix','tabletQty','deviceRegular','deviceDeuce'].forEach(function (key) {
          if (card.dataset[key] !== undefined) atcBtn.dataset[key] = card.dataset[key];
        });
        var ctaLabel = card.dataset.ctaLabel;
        if (ctaLabel) atcBtn.textContent = ctaLabel;
      }
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function () { selectCard(card); });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initCounters();
    initChart();
    initBeforeAfter();
    initFaq();
    initStickyBar();
    initCountdown();
    initTabletModal();
    initModelModal();
    initOfferCards();

    document.querySelectorAll('.lp-offer__btn').forEach(function (btn) {
      btn.addEventListener('click', function () { addBundleToCart(btn); });
    });

    var topbarCart = document.getElementById('hs-lp-topbar-cart');
    if (topbarCart) {
      topbarCart.addEventListener('click', function (e) { e.preventDefault(); openSideCart(); });
    }
    syncTopbarCartCount();
  });
})();
